import React from 'react';
import { connect } from 'react-redux';

import MiniCalendar from '../components/MiniCalendar/MiniCalendar';
import DesignerPreview from '../components/InfinityCalendar/DesignerPreview';
import Console from '../../../lib/debug';

const DesignerTOCContent = props => {
    Console.render('DesignerTOC');

    if (props.isProgram) {
        return <MiniCalendar />;
    }

    return <DesignerPreview />;
};

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        isProgram: state.calendar.infoTree.programType === 2
    };
};

export default connect(mapStateToProps)(DesignerTOCContent);



// WEBPACK FOOTER //
// ./src/view/designer/designer-base/DesignerTOC.jsx